<app-dialog
        (close)="close()"
        [title]="data?.title">
    <ng-container dialogContent>
        <div class="gallery-wrapper">
            <fui-button
                    class="gallery-prev"
                    type="button-icon"
                    [title]="appService.language_dictionary.system_back"
                    borderRadius="circle"
                    height="mini"
                    icon="chevron-left"
                    color="neutral"
                    (clickEvent)="this.galleryRef.prev();">
            </fui-button>
            <fui-button
                    class="gallery-next"
                    type="button-icon"
                    [title]="appService.language_dictionary.system_next"
                    borderRadius="circle"
                    height="mini"
                    icon="chevron-right"
                    color="neutral"
                    (clickEvent)="galleryRef.next();">
            </fui-button>
            <gallery [items]="images" id="gallery" gallerize>
            </gallery>
        </div>
    </ng-container>
</app-dialog>
<ng-template #lightboxTemplate>
    <div class="gallery-top-buttons">
        <fui-button
                class="gallery-download"
                type="button-icon"
                [title]="appService.language_dictionary.system_download"
                borderRadius="circle"
                height="mini"
                icon="download"
                color="soft-outline"
                (clickEvent)="downloadCurrentLightbox()">
        </fui-button>
        <fui-button
                class="gallery-fullscreen"
                type="button-icon"
                [title]="appService.language_dictionary.system_fullscreen"
                borderRadius="circle"
                height="mini"
                [icon]="isFullScreen ? 'fullscreen-exit' : 'fullscreen'"
                color="soft-outline"
                (clickEvent)="toggleLightboxFullScreen()">
        </fui-button>
        <fui-button
                class="gallery-close"
                type="button-icon"
                [title]="appService.language_dictionary.system_close"
                borderRadius="circle"
                height="mini"
                icon="close"
                color="soft-outline"
                (clickEvent)="closeLightbox()">
        </fui-button>
    </div>
    <fui-button
            class="gallery-prev"
            type="button-icon"
            [title]="appService.language_dictionary.system_back"
            borderRadius="circle"
            height="mini"
            icon="chevron-left"
            color="soft"
            (clickEvent)="lightboxRef.prev();">
    </fui-button>
    <fui-button
            class="gallery-next"
            type="button-icon"
            [title]="appService.language_dictionary.system_next"
            borderRadius="circle"
            height="mini"
            icon="chevron-right"
            color="soft"
            (clickEvent)="lightboxRef.next();">
    </fui-button>
</ng-template>
